<template>
  <v-dialog v-model="dialog" persistent max-width="650">
    <v-card v-if="getTutorial" class="px-4">
      <v-row class="pt-4">
        <v-col cols="12" class="d-flex">
          <h3 class="w100 my-auto pl-2 subheading">
            {{ getTutorial.name }}
          </h3>
          <v-btn small icon @click="dialog = false">
            <v-icon small> fas fa-times </v-icon>
          </v-btn>
        </v-col>
      </v-row>
      <v-row justify="center" class="pa-5 pb-10">
        <iframe
          width="560"
          height="315"
          :src="`${getTutorial.url}?autoplay=1`"
          title="YouTube video player"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen
        />
      </v-row>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  name: "TutorialModal",
  data: () => ({}),
  computed: {
    ...mapGetters(["showTutorialModal", "getTutorial"]),
    dialog: {
      get() {
        return this.showTutorialModal;
      },
      set(value) {
        this.setShowTutorialModal(value);
      },
    },
  },
  methods: {
    ...mapActions(["setShowTutorialModal"]),
  },
};
</script>
